import { marker } from "@jsverse/transloco-keys-manager/marker";
import { sntTranslate } from "src/app/support/translate";

export interface Signature {
  id: string;
  resource: string;
  type: "otp" | "graphometric";
  completedAt?: Date;
  signedBy: {
    id: string;
    name: string;
  };
  otp?: string;
  email?: string;
  phone?: string;
}

export type SignatureCreate = Pick<Signature, "resource" | "signedBy">;

export function getSignatureFileName(
  omitFileExtension: boolean = false
): string {
  let text = `${sntTranslate(marker("Scheda paziente"))}`;

  return omitFileExtension ? text : `${text}.pdf`;
}
